module.exports = __webpack_public_path__ + "5953bac492f4c003a0870baa937a743d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/25.jpg
// module id = 1352
// module chunks = 47